import React from 'react'
import '../css/admin/AdminDashboard.css'
import { FaBuilding, FaCheckCircle, FaUsers } from 'react-icons/fa';
import { BiSolidPhoneCall } from 'react-icons/bi';
import { MdBorderColor } from 'react-icons/md';
import { BiRupee } from 'react-icons/bi';
import { Bar } from 'react-chartjs-2'
import { useState, useEffect } from 'react';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from 'chart.js';
import axios from "axios";
import { useLoading } from '../context/LoadingContext';
import { useNavigate } from 'react-router-dom';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


const AdminDashboard = ({adminData, companyID, branchID}) => {
     const navigate = useNavigate();
    const { setLoading } = useLoading();
    const [detail, setDetail] = useState([]);
    const [branches, setBranches] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [user, setUser] = useState([]);
    const [pmsService, setPmsService] = useState([]);
    const [fetchSale, setFetchSale] = useState([]);
    const [purchase, setPurchase] = useState([]);
    const [party, setParty] = useState([]);
    const [callList, setCallList] = useState([]);
    const [FollowUpList, setFollowUpList] = useState([]);
    const [bankAccount, setBankAccount] = useState([]);
    const [cashAccount, setCashAccount] = useState([]);

    const [bankReceipts, setBankReceipts] = useState([]);
    const [cashReceipts, setCashReceipts] = useState([]);
      const [greeting, setGreeting] = useState('');
      const [fromDate, setFromDate] = useState('');
const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([]);
    const [company, setCompany] = useState([]);

    const expenseData = {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        datasets: [
            {
                label: 'Daily Expenses',
                data: [80, 150, 250, 200, 180, 260, 300],
                backgroundColor: 'rgba(220, 53, 69, 0.6)',
                borderColor: 'rgba(220, 53, 69, 1)',
                borderWidth: 1,
                borderRadius: 6,
            },
        ],
    };

    const totalCash = cashAccount.reduce((acc, item) => acc + Number(item.amount || 0), 0);
    const totalBank = bankAccount.reduce((acc, item) => acc + Number(item.amount || 0), 0);

    const data = {
        labels: ["Cash Payment", "Bank Payment"],
        datasets: [
            {
                label: "Total Payment",
                data: [totalCash, totalBank],
                backgroundColor: ["#4caf50", "#2196f3"]
            }
        ]
    };


    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: true, text: "Current Month Payments" }
        },
        scales: {
            y: { beginAtZero: true }
        }
    };

    const totalCashReceipts = cashReceipts.reduce(
        (acc, item) => acc + Number(item.amount || 0),
        0
    );
    const totalBankReceipts = bankReceipts.reduce(
        (acc, item) => acc + Number(item.amount || 0),
        0
    );

    const receiptData = {
        labels: ['Cash Receipts', 'Bank Receipts'],
        datasets: [
            {
                label: 'Total Receipts (Current Month)',
                data: [totalCashReceipts, totalBankReceipts],
                backgroundColor: ['#ff9800', '#3f51b5'],
            },
        ],
    };

    const receiptOptions = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: true, text: 'Current Month Receipts' },
        },
        scales: {
            y: { beginAtZero: true },
        },
    };


    const isWithinDateRange = (dateStr) => {
  if (!fromDate || !toDate) return true;

  const date = new Date(dateStr.split(" ")[0]);
  const from = new Date(fromDate);
  const to = new Date(toDate);

  return date >= from && date <= to;
};


const handleFilter = () => {
  fetchPayments();
  fetchReceipts();
  fetchSaleInvoice();
  fetchPurchaseDetail();
  fetchComplaints();
};


  
    const fetchCompany = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`https://api.skyguard.group/api/fetch-detail`);
            setCompany(res.data.result);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const fetchBranch = async () => {
        try {
            const resBranch = await axios.get('https://api.skyguard.group/api/fetch-branch');
            setBranches(resBranch.data.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchEmployee = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');

            const employees = resEmployee.data.result.filter(
                emp => emp.emp_id != null && emp.emp_code != null
            );
            setUser(employees);

        } catch (error) {
            console.log(error)
        }
    };

    const fetchPmsDetail = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                "https://api.skyguard.group/api/fetch-pms-schedules"
            );
            // setPmsService(res.data);
              const filteredData = res.data.filter(item => {
            if (!item.created_date) return true; 
            return isWithinDateRange(item.created_date);
        });

        setPmsService(filteredData);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


    const fetchSaleInvoice = async () => {
        setLoading(true)
        try {
            const response = await axios.get('https://api.skyguard.group/api/fetch-sale-invoice');
            // const saleInvoiceOnly = response.data.filter(
            //     item => item.type_acc === "sale_invoice"
            // );

            const saleInvoiceOnly = response.data.filter(
  item => item.type_acc === "sale_invoice" && isWithinDateRange(item.quotation_date)
);
            setFetchSale(saleInvoiceOnly);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    const fetchPurchaseDetail = async () => {
        setLoading(true);
        try {
            const resPurchase = await axios.get("https://api.skyguard.group/api/fetch-purchase");

            const data = Array.isArray(resPurchase.data)
                ? resPurchase.data
                : resPurchase.data?.data || [];

            // const purchaseOnly = data.filter(item => item.type_acc === "Purchase");
            const purchaseOnly = data.filter(
  item => item.type_acc === "Purchase" && isWithinDateRange(item.date)
);

            setPurchase(purchaseOnly)
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


    const fecthPartyDetail = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-party');
          

               const filteredData = res.data.filter(item => {
            if (!item.added_date) return true; 
            return isWithinDateRange(item.added_date);
        });
            setParty(filteredData)
        } catch (error) {
            console.log(error);
        }
    };

    const fetchComplaints = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-complaint");
            const complaints = res.data;

            const today = new Date();
            const todayStr = today.toISOString().slice(0, 10);

            // const todayComplaints = complaints.filter(complaint => {
            //     if (!complaint.date) return false;

            //     const complaintDate = complaint.date.split(" ")[0];
            //     return complaintDate === todayStr;
            // });

            const todayComplaints = complaints.filter(complaint => {
  if (!complaint.date) return false;
  return isWithinDateRange(complaint.date);
});

            const complaintsWithDetails = todayComplaints.map(complaint => ({
                ...complaint,
                parsedItemDetails: JSON.parse(complaint.item_details || "[]")
            }));

            setCallList(complaintsWithDetails);

        } catch (err) {
            console.error(err);
        }
    };

    const fetchFollowUps = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/followups');

              const filteredData = res.data.filter(item => {
            if (!item.followup_date) return true; 
            return isWithinDateRange(item.created_at);
        });

        setFollowUpList(filteredData);
            // setFollowUpList(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    const fetchReceipts = async () => {
        try {
            const [cashRes, bankRes] = await Promise.all([
                axios.get('https://api.skyguard.group/api/fetch-cash-receipt'),
                axios.get('https://api.skyguard.group/api/fetch-bank-receipt'),
            ]);

            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth() + 1;


            // const filteredCash = cashRes.data.filter((r) => {
            //     if (r.payment_type !== 'cash_receipt') return false;
            //     const [datePart] = r.payment_date.trim().split(' ');
            //     const [year, month] = datePart.split('-').map(Number);
            //     return year === currentYear && month === currentMonth;
            // });

            // const filteredBank = bankRes.data.filter((r) => {
            //     if (r.payment_type !== 'bank_receipt') return false;
            //     const [datePart] = r.payment_date.trim().split(' ');
            //     const [year, month] = datePart.split('-').map(Number);
            //     return year === currentYear && month === currentMonth;
            // });

            const filteredCash = cashRes.data.filter(r => {
  if (r.payment_type !== 'cash_receipt') return false;
  return isWithinDateRange(r.payment_date);
});

const filteredBank = bankRes.data.filter(r => {
  if (r.payment_type !== 'bank_receipt') return false;
  return isWithinDateRange(r.payment_date);
});

            setCashReceipts(filteredCash);
            setBankReceipts(filteredBank);


        } catch (err) {
            console.error(err);
        }
    };

     const fetchBranchDetail = async () => {
            setLoading(true)
            try {
                const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
                setBranchDetail(resInventory.data)
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false);
            }
        };

     

    useEffect(() => {
        fetchCompany();
        fetchBranch();
        fetchEmployee();
        fetchPmsDetail();
        fetchSaleInvoice();
        fetchPurchaseDetail();
        fecthPartyDetail();
        fetchComplaints();
        fetchFollowUps();
        fetchPayments();
        fetchReceipts();
        fetchBranchDetail();
    }, []);





    const fetchPayments = async () => {
        setLoading(true);

        try {
            const [cashRes, bankRes] = await Promise.all([
                axios.get("https://api.skyguard.group/api/fetch-cash-payment"),
                axios.get("https://api.skyguard.group/api/fetch-bank-payment")
            ]);

            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth() + 1; // JS months 0-11


            const cashData = cashRes.data.filter(payment => {
  if (payment.payment_type !== "cash_payment") return false;
  return isWithinDateRange(payment.payment_date);
});

const bankData = bankRes.data.filter(payment => {
  if (payment.payment_type !== "bank_payment") return false;
  return isWithinDateRange(payment.payment_date);
});

            setCashAccount(cashData);
            setBankAccount(bankData);

      

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

  useEffect(() => {
    const hour = new Date().getHours(); 

    if (hour >= 5 && hour < 12) {
      setGreeting('Good Morning!');
    } else if (hour >= 12 && hour < 17) {
      setGreeting('Good Afternoon!');
    } else {
      setGreeting('Good Evening!');
    }
  }, []);



  useEffect(() => {
  if (fromDate && toDate) {
    handleFilter();
  }
}, [fromDate, toDate]);

    return (
        <div className='main-section'>
            <div className="container-fluid dashboard-wrapper p-3 bg-body-secondary">
                <h3 className='my-3 fw-bold fs-5 golos'>Dashboard</h3> 
              
       
                {/* Header */}
                <div className="welcome-banner d-flex justify-content-between bg-black bg-gradient align-items-center flex-wrap p-3 mb-4">
                    <div>
                        <h3 className="text-white mb-1 golos">Welcome! Admin</h3>
                        <p className="text-white golos">{greeting} </p>
                    </div>
                    <div className="btn-group mt-3 mt-md-0">
                        <button className="btn btn-primary">Summary</button>
                        {/* <button className="btn btn-light">Recents</button> */}
                    </div>


  
                </div>


                                  <div className="row mb-3">
  <div className="col-md-3">
    <label>From Date</label>
    <input
      type="date"
      className="form-control"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  <div className="col-md-3">
    <label>To Date</label>
    <input
      type="date"
      className="form-control"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

  <div className="col-md-3 d-flex align-items-end">
    <button className="btn btn-success " onClick={handleFilter}>
      Apply Filter
    </button>
  </div>
</div>

                {/* Cards Section */}
                <div className="row g-3">
                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between">
                                <div>
                                    <h6>Companies and Branches</h6>

                                    <p className='mb-0' onClick={ () => navigate('/admin/companies')}><strong> Total Company:</strong> {company.length}   </p>
                                    <p onClick={ () => navigate('/admin/branches')}><strong> Total Branch: </strong> {branches.length}  </p>
                                </div>
                                <FaBuilding className="icon text-primary" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between" onClick={ () => navigate('/admin/employee')}>
                                <div>
                                    <h6>Total Employee</h6>
                                    <h4>{user.length} </h4>

                                </div>
                                <FaUsers className="icon text-success" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between" onClick={ () => navigate('/admin/generate-pms')}>
                                <div>
                                    <h6>Total PMS Services</h6>
                                    <h4>{pmsService.length} </h4>

                                </div>
                                <FaCheckCircle className="icon text-warning" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between" onClick={ () => navigate('/admin/sale-invoice')}>
                                <div>
                                    <h6>Total Sale</h6>
                                    <h4>{fetchSale.length} </h4>

                                </div>
                                <BiRupee className="icon text-danger" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between" onClick={ () => navigate('/admin/purchase')}>
                                <div>
                                    <h6>Total Purchase</h6>
                                    <h4>{purchase.length} </h4>

                                </div>
                                <BiRupee className="icon text-danger" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between" onClick={ () => navigate('/admin/crm/complaint')}>
                                <div>
                                    <h6>Todays Call</h6>
                                    <h4>{callList.length} </h4>

                                </div>
                                <BiSolidPhoneCall className="icon text-primary" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between" onClick={ () => navigate('/admin/party')}>
                                <div>
                                    <h6>Total Party</h6>
                                    <h4> {party.length} </h4>

                                </div>
                                <FaUsers className="icon text-success" />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-3">
                        <div className="info-card card shadow h-100">
                            <div className="card-body d-flex align-items-center justify-content-between"  onClick={ () => navigate('/admin/crm/followup')}>
                                <div>
                                    <h6>Total FollowUp</h6>
                                    <h4>{FollowUpList.length} </h4>

                                </div>
                                <MdBorderColor className="icon text-success" />
                            </div>
                        </div>
                    </div>

                    {/* ======================================= Barchart-section =================================================== */}
                    <div className="container my-4">
                        <div className="row g-4">
                            {/* Daily payment Chart */}


                            <div className="col-md-6">
                                <div className="card shadow-sm h-100">
                                    <div className="card-body">
                                        <h5 className="card-title text-center text-success">Current Month Payments</h5>
                                        <div className="chart-container" style={{ height: "300px" }}>
                                            <Bar data={data} options={options} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Daily Expenses Chart */}


                            <div className="col-md-6">
                                <div className="card shadow-sm h-100">
                                    <div className="card-body">
                                        <h5 className="card-title text-center text-warning">
                                            Current Month Receipts
                                        </h5>
                                        <div className="chart-container" style={{ height: '300px' }}>
                                            <Bar data={receiptData} receiptOptions={receiptOptions} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default AdminDashboard;